// src/pages/ZimmetYonetimiPage.js
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const KATEGORILER = ['Bilgisayar', 'Telefon', 'Tablet', 'Araç', 'Ofis Ekipmanı', 'Yazılım Lisansı', 'Diğer'];

const durumRenk = { musait: '#059669', atandi: '#4F46E5', arizali: '#DC2626', kayip: '#9CA3AF' };
const durumEtiket = { musait: 'Müsait', atandi: 'Atandı', arizali: 'Arızalı', kayip: 'Kayıp' };
const fmt = (t) => t ? new Date(t).toLocaleDateString('tr-TR') : '-';

export default function ZimmetYonetimiPage() {
  const [sekme, setSekme] = useState(() => {
    const path = window.location.pathname;
    const alt = path.split('/')[2];
    return ['tanimlar','atamalar'].includes(alt) ? alt : 'tanimlar';
  });

  React.useEffect(() => {
    window.history.pushState({ sekme }, '', '/zimmet-yonetimi/' + sekme);
    document.title = {tanimlar:'Zimmet Tanımları', atamalar:'Aktif Atamalar'}[sekme] + ' - Valure HR';
  }, [sekme]);

  React.useEffect(() => {
    const handlePop = () => {
      const alt = window.location.pathname.split('/')[2];
      if (alt && ['tanimlar','atamalar'].includes(alt)) setSekme(alt);
    };
    window.addEventListener('popstate', handlePop);
    return () => window.removeEventListener('popstate', handlePop);
  }, []);
  const [zimmetler, setZimmetler] = useState([]);
  const [atamalar, setAtamalar] = useState([]);
  const [personeller, setPersoneller] = useState([]);
  const [istatistik, setIstatistik] = useState({});
  const [yukleniyor, setYukleniyor] = useState(true);
  const [aramaMetni, setAramaMetni] = useState('');
  const [filtreKategori, setFiltreKategori] = useState('');
  const [filtreDurum, setFiltreDurum] = useState('');
  const [modalTur, setModalTur] = useState(null); // 'yeni' | 'duzenle' | 'ata' | 'iade'
  const [secili, setSecili] = useState(null);
  const [hata, setHata] = useState('');
  const [basari, setBasari] = useState('');

  const [zimmetForm, setZimmetForm] = useState({
    ad: '', kategori: '', marka: '', model: '', seri_no: '', barkod: '',
    satin_alma_tarihi: '', satin_alma_bedeli: '', aciklama: ''
  });
  const [ataForm, setAtaForm] = useState({ kullanici_id: '', atama_tarihi: '', atama_notu: '' });
  const [hizliAtaForm, setHizliAtaForm] = useState({ 
    kullanici_id: '', zimmet_id: '', atama_tarihi: new Date().toISOString().slice(0,10), atama_notu: '',
    // Yeni zimmet oluştur alanları
    yeniZimmet: false, ad: '', kategori: '', marka: '', model: '', seri_no: ''
  });
  const [iadeForm, setIadeForm] = useState({ iade_tarihi: '', iade_notu: '' });

  const getir = useCallback(async () => {
    try {
      setYukleniyor(true);
      const [zimR, ataR, perR, istR] = await Promise.all([
        axios.get('/api/zimmet/tanimlar'),
        axios.get('/api/zimmet/atamalar'),
        axios.get('/api/personel-karti/'),
        axios.get('/api/zimmet/istatistik'),
      ]);
      setZimmetler(zimR.data);
      setAtamalar(ataR.data);
      setPersoneller(perR.data);
      setIstatistik(istR.data);
    } catch { setHata('Veriler yüklenemedi'); }
    finally { setYukleniyor(false); }
  }, []);

  useEffect(() => { getir(); }, [getir]);

  const modalAc = (tur, item = null) => {
    setSecili(item);
    setHata(''); setBasari('');
    if (tur === 'yeni') {
      setZimmetForm({ ad: '', kategori: '', marka: '', model: '', seri_no: '', barkod: '', satin_alma_tarihi: '', satin_alma_bedeli: '', aciklama: '' });
    } else if (tur === 'duzenle' && item) {
      setZimmetForm({ ad: item.ad, kategori: item.kategori, marka: item.marka||'', model: item.model||'', seri_no: item.seri_no||'', barkod: item.barkod||'', satin_alma_tarihi: item.satin_alma_tarihi||'', satin_alma_bedeli: item.satin_alma_bedeli||'', aciklama: item.aciklama||'' });
    } else if (tur === 'ata') {
      setAtaForm({ kullanici_id: '', atama_tarihi: new Date().toISOString().slice(0,10), atama_notu: '' });
    } else if (tur === 'hizliAta') {
      setHizliAtaForm({ kullanici_id: '', zimmet_id: '', atama_tarihi: new Date().toISOString().slice(0,10), atama_notu: '', yeniZimmet: false, ad: '', kategori: '', marka: '', model: '', seri_no: '' });
    } else if (tur === 'iade') {
      setIadeForm({ iade_tarihi: new Date().toISOString().slice(0,10), iade_notu: '' });
    }
    setModalTur(tur);
  };

  const kaydet = async () => {
    if (!zimmetForm.ad || !zimmetForm.kategori) { setHata('Ad ve kategori zorunludur'); return; }
    try {
      if (modalTur === 'yeni') {
        await axios.post('/api/zimmet/tanimlar', zimmetForm);
      } else {
        await axios.put(`/api/zimmet/tanimlar/${secili.id}`, zimmetForm);
      }
      setBasari('Kaydedildi');
      setTimeout(() => { setModalTur(null); getir(); }, 600);
    } catch (err) { setHata(err.response?.data?.hata || 'Hata oluştu'); }
  };

  const hizliAtaKaydet = async () => {
    if (!hizliAtaForm.kullanici_id || !hizliAtaForm.atama_tarihi) { setHata('Personel ve tarih zorunludur'); return; }
    try {
      let zimmetId = hizliAtaForm.zimmet_id;
      // Yeni zimmet oluştur
      if (hizliAtaForm.yeniZimmet) {
        if (!hizliAtaForm.ad || !hizliAtaForm.kategori) { setHata('Zimmet adı ve kategorisi zorunludur'); return; }
        const r = await axios.post('/api/zimmet/tanimlar', {
          ad: hizliAtaForm.ad, kategori: hizliAtaForm.kategori,
          marka: hizliAtaForm.marka, model: hizliAtaForm.model, seri_no: hizliAtaForm.seri_no
        });
        zimmetId = r.data.id;
      }
      if (!zimmetId) { setHata('Zimmet seçin veya yeni oluşturun'); return; }
      await axios.post('/api/zimmet/ata', { zimmet_id: zimmetId, kullanici_id: hizliAtaForm.kullanici_id, atama_tarihi: hizliAtaForm.atama_tarihi, atama_notu: hizliAtaForm.atama_notu });
      setBasari('Zimmet atandı');
      setTimeout(() => { setModalTur(null); getir(); }, 600);
    } catch(err) { setHata(err.response?.data?.hata || 'Hata oluştu'); }
  };

  const atamaYap = async () => {
    if (!ataForm.kullanici_id || !ataForm.atama_tarihi) { setHata('Personel ve tarih zorunludur'); return; }
    try {
      await axios.post('/api/zimmet/ata', { zimmet_id: secili.id, ...ataForm });
      setBasari('Zimmet atandı');
      setTimeout(() => { setModalTur(null); getir(); }, 600);
    } catch (err) { setHata(err.response?.data?.hata || 'Hata'); }
  };

  const iadeAl = async () => {
    if (!iadeForm.iade_tarihi) { setHata('İade tarihi zorunludur'); return; }
    try {
      await axios.post(`/api/zimmet/iade/${secili.id}`, iadeForm);
      setBasari('Zimmet iade alındı');
      setTimeout(() => { setModalTur(null); getir(); }, 600);
    } catch (err) { setHata(err.response?.data?.hata || 'Hata'); }
  };

  const filtrelenmisZimmetler = zimmetler.filter(z => {
    const aramaUyum = !aramaMetni || z.ad.toLowerCase().includes(aramaMetni.toLowerCase()) || (z.seri_no||'').toLowerCase().includes(aramaMetni.toLowerCase());
    const katUyum = !filtreKategori || z.kategori === filtreKategori;
    const durumUyum = !filtreDurum || z.durum === filtreDurum;
    return aramaUyum && katUyum && durumUyum;
  });

  return (
    <div style={{ padding: '24px', maxWidth: '1100px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div>
          <h1 style={{ fontSize: '24px', fontWeight: 700, color: '#111827', margin: 0 }}>🖥️ Zimmet Yönetimi</h1>
          <p style={{ color: '#6B7280', marginTop: '4px', fontSize: '14px' }}>{istatistik.toplam || 0} zimmet · {istatistik.atandi || 0} atandı · {istatistik.musait || 0} müsait</p>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={() => modalAc('hizliAta')} style={{ background: '#059669', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontWeight: 600 }}>
            👤 Zimmet Ata
          </button>
          <button onClick={() => modalAc('yeni')} style={{ background: '#4F46E5', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontWeight: 600 }}>
            + Yeni Zimmet
          </button>
        </div>
      </div>

      {basari && <div style={{ background: '#F0FDF4', color: '#16A34A', padding: '10px 14px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px' }}>✅ {basari}</div>}

      {/* İstatistik kartlar */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '20px' }}>
        {[
          { label: 'Toplam', deger: istatistik.toplam || 0, renk: '#4F46E5' },
          { label: 'Müsait', deger: istatistik.musait || 0, renk: '#059669' },
          { label: 'Atandı', deger: istatistik.atandi || 0, renk: '#2563EB' },
          { label: 'Kategori', deger: (istatistik.kategoriler || []).length, renk: '#D97706' },
        ].map(item => (
          <div key={item.label} style={{ background: '#fff', borderRadius: '10px', border: '1px solid #E5E7EB', padding: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
            <div style={{ fontSize: '24px', fontWeight: 700, color: item.renk }}>{item.deger}</div>
            <div style={{ fontSize: '12px', color: '#6B7280', marginTop: '4px' }}>{item.label}</div>
          </div>
        ))}
      </div>

      {/* Sekmeler */}
      <div style={{ display: 'flex', borderBottom: '1px solid #E5E7EB', marginBottom: '20px' }}>
        {[['tanimlar','🖥️ Zimmet Tanımları'],['atamalar','👤 Aktif Atamalar']].map(([k,l]) => (
          <button key={k} onClick={() => setSekme(k)} style={{
            padding: '10px 20px', border: 'none', background: 'none', cursor: 'pointer',
            fontSize: '14px', fontWeight: sekme === k ? 700 : 400,
            color: sekme === k ? '#4F46E5' : '#6B7280',
            borderBottom: sekme === k ? '2px solid #4F46E5' : '2px solid transparent'
          }}>{l}</button>
        ))}
      </div>

      {sekme === 'tanimlar' && (
        <>
          {/* Filtreler */}
          <div style={{ display: 'flex', gap: '10px', marginBottom: '16px', flexWrap: 'wrap' }}>
            <div style={{ position: 'relative', flex: 1, minWidth: '200px' }}>
              <span style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF' }}>🔍</span>
              <input value={aramaMetni} onChange={e => setAramaMetni(e.target.value)} placeholder="Zimmet veya seri no ara..."
                style={{ width: '100%', padding: '9px 12px 9px 34px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
            </div>
            <select value={filtreKategori} onChange={e => setFiltreKategori(e.target.value)}
              style={{ padding: '9px 14px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px' }}>
              <option value="">Tüm Kategoriler</option>
              {KATEGORILER.map(k => <option key={k} value={k}>{k}</option>)}
            </select>
            <select value={filtreDurum} onChange={e => setFiltreDurum(e.target.value)}
              style={{ padding: '9px 14px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px' }}>
              <option value="">Tüm Durumlar</option>
              {Object.entries(durumEtiket).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </div>

          {yukleniyor ? (
            <div style={{ textAlign: 'center', padding: '60px', color: '#9CA3AF' }}>Yükleniyor...</div>
          ) : (
            <div style={{ display: 'grid', gap: '10px' }}>
              {filtrelenmisZimmetler.map(z => (
                <div key={z.id} style={{ background: '#fff', borderRadius: '10px', border: '1px solid #E5E7EB', padding: '14px 18px', display: 'flex', alignItems: 'center', gap: '14px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                  <div style={{ width: '40px', height: '40px', borderRadius: '8px', background: '#EEF2FF', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', flexShrink: 0 }}>
                    {z.kategori === 'Bilgisayar' ? '💻' : z.kategori === 'Telefon' ? '📱' : z.kategori === 'Araç' ? '🚗' : z.kategori === 'Tablet' ? '📱' : '🖥️'}
                  </div>

                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                      <span style={{ fontWeight: 700, fontSize: '14px', color: '#111827' }}>{z.ad}</span>
                      <span style={{ background: '#F3F4F6', color: '#374151', fontSize: '11px', padding: '1px 7px', borderRadius: '4px', fontWeight: 600 }}>{z.kategori}</span>
                      <span style={{ background: durumRenk[z.durum] + '15', color: durumRenk[z.durum], fontSize: '11px', padding: '1px 7px', borderRadius: '4px', fontWeight: 700 }}>{durumEtiket[z.durum]}</span>
                    </div>
                    <div style={{ fontSize: '12px', color: '#6B7280', marginTop: '3px' }}>
                      {z.marka && `${z.marka} `}{z.model && `${z.model} · `}{z.seri_no && `SN: ${z.seri_no}`}
                    </div>

                  </div>

                  <div style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
                    {z.durum === 'musait' && (
                      <button onClick={() => modalAc('ata', z)} style={{ background: '#F0FDF4', color: '#059669', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}>Ata</button>
                    )}
                    <button onClick={() => modalAc('duzenle', z)} style={{ background: '#EEF2FF', color: '#4F46E5', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}>Düzenle</button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {sekme === 'atamalar' && (
        <div style={{ display: 'grid', gap: '10px' }}>
          {atamalar.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px', background: '#F9FAFB', borderRadius: '12px', border: '2px dashed #E5E7EB' }}>
              <div style={{ fontSize: '40px', marginBottom: '8px' }}>👤</div>
              <p style={{ color: '#6B7280' }}>Aktif zimmet ataması yok</p>
            </div>
          ) : atamalar.map(a => (
            <div key={a.id} style={{ background: '#fff', borderRadius: '10px', border: '1px solid #E5E7EB', padding: '14px 18px', display: 'flex', alignItems: 'center', gap: '14px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
              <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#4F46E5', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', fontWeight: 700, flexShrink: 0 }}>
                {a.personel_ad?.charAt(0)}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: '14px', color: '#111827' }}>{a.personel_ad}</div>
                <div style={{ fontSize: '13px', color: '#4F46E5', marginTop: '2px' }}>🖥️ {a.zimmet_ad}</div>
                <div style={{ fontSize: '12px', color: '#9CA3AF', marginTop: '2px' }}>{a.kategori} · {a.marka} {a.model} · Atandı: {fmt(a.atama_tarihi)}</div>
              </div>
              <button onClick={() => modalAc('iade', a)} style={{ background: '#FEF3C7', color: '#92400E', border: 'none', padding: '7px 14px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '12px' }}>
                İade Al
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Modaller */}
      {(modalTur === 'yeni' || modalTur === 'duzenle') && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '16px', padding: '32px', width: '100%', maxWidth: '540px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 25px 50px rgba(0,0,0,0.25)' }}>
            <h2 style={{ fontSize: '20px', fontWeight: 700, margin: '0 0 20px' }}>{modalTur === 'yeni' ? '+ Yeni Zimmet' : '✏️ Zimmet Düzenle'}</h2>
            {hata && <div style={{ background: '#FEF2F2', color: '#DC2626', padding: '10px', borderRadius: '8px', marginBottom: '14px', fontSize: '14px' }}>⚠️ {hata}</div>}
            {basari && <div style={{ background: '#F0FDF4', color: '#16A34A', padding: '10px', borderRadius: '8px', marginBottom: '14px', fontSize: '14px' }}>✅ {basari}</div>}

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
              {[
                { label: 'Ad *', key: 'ad', placeholder: 'örn: MacBook Pro 14"', full: true },
                { label: 'Kategori *', key: 'kategori', type: 'select', options: KATEGORILER },
                { label: 'Marka', key: 'marka', placeholder: 'Apple, Dell...' },
                { label: 'Model', key: 'model', placeholder: 'MBP M3...' },
                { label: 'Seri No', key: 'seri_no', placeholder: 'Benzersiz seri no' },
                { label: 'Barkod', key: 'barkod', placeholder: 'Barkod/QR' },
                { label: 'Satın Alma Tarihi', key: 'satin_alma_tarihi', type: 'date' },
                { label: 'Satın Alma Bedeli', key: 'satin_alma_bedeli', type: 'number', placeholder: '0.00' },
              ].map(f => (
                <div key={f.key} style={{ gridColumn: f.full ? '1 / -1' : 'auto' }}>
                  <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>{f.label}</label>
                  {f.type === 'select' ? (
                    <select value={zimmetForm[f.key]} onChange={e => setZimmetForm(fm => ({ ...fm, [f.key]: e.target.value }))}
                      style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                      <option value="">— Seçin —</option>
                      {f.options.map(o => <option key={o} value={o}>{o}</option>)}
                    </select>
                  ) : (
                    <input type={f.type || 'text'} value={zimmetForm[f.key]} onChange={e => setZimmetForm(fm => ({ ...fm, [f.key]: e.target.value }))}
                      placeholder={f.placeholder}
                      style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
                  )}
                </div>
              ))}
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Açıklama</label>
                <textarea value={zimmetForm.aciklama} onChange={e => setZimmetForm(fm => ({ ...fm, aciklama: e.target.value }))} rows={2}
                  style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', resize: 'vertical', boxSizing: 'border-box' }} />
              </div>
            </div>

            <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
              <button onClick={() => setModalTur(null)} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1.5px solid #E5E7EB', background: '#fff', cursor: 'pointer', fontWeight: 600 }}>İptal</button>
              <button onClick={kaydet} style={{ flex: 2, padding: '10px', borderRadius: '8px', border: 'none', background: '#4F46E5', color: '#fff', cursor: 'pointer', fontWeight: 600 }}>{modalTur === 'yeni' ? 'Oluştur' : 'Güncelle'}</button>
            </div>
          </div>
        </div>
      )}

      {modalTur === 'ata' && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '16px', padding: '32px', width: '100%', maxWidth: '420px', boxShadow: '0 25px 50px rgba(0,0,0,0.25)' }}>
            <h2 style={{ fontSize: '20px', fontWeight: 700, margin: '0 0 8px' }}>Zimmet Ata</h2>
            <p style={{ color: '#6B7280', fontSize: '14px', marginBottom: '20px' }}><strong>{secili?.ad}</strong> zimmetini kime atamak istiyorsunuz?</p>
            {hata && <div style={{ background: '#FEF2F2', color: '#DC2626', padding: '10px', borderRadius: '8px', marginBottom: '14px', fontSize: '14px' }}>⚠️ {hata}</div>}
            {basari && <div style={{ background: '#F0FDF4', color: '#16A34A', padding: '10px', borderRadius: '8px', marginBottom: '14px', fontSize: '14px' }}>✅ {basari}</div>}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Personel *</label>
                <select value={ataForm.kullanici_id} onChange={e => setAtaForm(f => ({ ...f, kullanici_id: e.target.value }))}
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                  <option value="">— Personel seçin —</option>
                  {personeller.map(p => <option key={p.id} value={p.id}>{p.ad} {p.soyad}</option>)}
                </select>
              </div>
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Atama Tarihi *</label>
                <input type="date" value={ataForm.atama_tarihi} onChange={e => setAtaForm(f => ({ ...f, atama_tarihi: e.target.value }))}
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Not</label>
                <input value={ataForm.atama_notu} onChange={e => setAtaForm(f => ({ ...f, atama_notu: e.target.value }))} placeholder="İsteğe bağlı not"
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
              <button onClick={() => setModalTur(null)} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1.5px solid #E5E7EB', background: '#fff', cursor: 'pointer', fontWeight: 600 }}>İptal</button>
              <button onClick={atamaYap} style={{ flex: 2, padding: '10px', borderRadius: '8px', border: 'none', background: '#059669', color: '#fff', cursor: 'pointer', fontWeight: 600 }}>Ata</button>
            </div>
          </div>
        </div>
      )}

      {modalTur === 'hizliAta' && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '16px', padding: '32px', width: '100%', maxWidth: '520px', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 25px 50px rgba(0,0,0,0.25)' }}>
            <h2 style={{ fontSize: '20px', fontWeight: 700, margin: '0 0 20px' }}>👤 Zimmet Ata</h2>
            {hata && <div style={{ background: '#FEF2F2', color: '#DC2626', padding: '10px', borderRadius: '8px', marginBottom: '14px', fontSize: '14px' }}>⚠️ {hata}</div>}
            {basari && <div style={{ background: '#F0FDF4', color: '#16A34A', padding: '10px', borderRadius: '8px', marginBottom: '14px', fontSize: '14px' }}>✅ {basari}</div>}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Personel *</label>
                <select value={hizliAtaForm.kullanici_id} onChange={e => setHizliAtaForm(f => ({...f, kullanici_id: e.target.value}))}
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                  <option value="">— Personel seçin —</option>
                  {personeller.map(p => <option key={p.id} value={p.id}>{p.ad} {p.soyad}</option>)}
                </select>
              </div>

              <div style={{ background: '#F9FAFB', borderRadius: '10px', padding: '14px' }}>
                <div style={{ display: 'flex', gap: '10px', marginBottom: '12px' }}>
                  <button onClick={() => setHizliAtaForm(f => ({...f, yeniZimmet: false}))}
                    style={{ flex: 1, padding: '8px', border: `2px solid ${!hizliAtaForm.yeniZimmet ? '#4F46E5' : '#E5E7EB'}`, borderRadius: '8px', background: !hizliAtaForm.yeniZimmet ? '#EEF2FF' : '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '13px', color: !hizliAtaForm.yeniZimmet ? '#4F46E5' : '#6B7280' }}>
                    Mevcut Zimmeti Ata
                  </button>
                  <button onClick={() => setHizliAtaForm(f => ({...f, yeniZimmet: true}))}
                    style={{ flex: 1, padding: '8px', border: `2px solid ${hizliAtaForm.yeniZimmet ? '#059669' : '#E5E7EB'}`, borderRadius: '8px', background: hizliAtaForm.yeniZimmet ? '#F0FDF4' : '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '13px', color: hizliAtaForm.yeniZimmet ? '#059669' : '#6B7280' }}>
                    + Yeni Zimmet Oluştur
                  </button>
                </div>

                {!hizliAtaForm.yeniZimmet ? (
                  <div>
                    <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Zimmet *</label>
                    <select value={hizliAtaForm.zimmet_id} onChange={e => setHizliAtaForm(f => ({...f, zimmet_id: e.target.value}))}
                      style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                      <option value="">— Zimmet seçin —</option>
                      {zimmetler.map(z => (
                        <option key={z.id} value={z.id}>{z.ad} {z.marka ? '- ' + z.marka : ''} {z.seri_no ? '(SN: ' + z.seri_no + ')' : ''}</option>
                      ))}
                    </select>
                
                  </div>
                ) : (
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                    <div style={{ gridColumn: '1/-1' }}>
                      <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Zimmet Adı *</label>
                      <input value={hizliAtaForm.ad} onChange={e => setHizliAtaForm(f => ({...f, ad: e.target.value}))} placeholder="örn: MacBook Pro 14&quot;" 
                        style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
                    </div>
                    <div>
                      <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Kategori *</label>
                      <select value={hizliAtaForm.kategori} onChange={e => setHizliAtaForm(f => ({...f, kategori: e.target.value}))}
                        style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                        <option value="">— Seçin —</option>
                        {KATEGORILER.map(k => <option key={k} value={k}>{k}</option>)}
                      </select>
                    </div>
                    <div>
                      <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Marka</label>
                      <input value={hizliAtaForm.marka} onChange={e => setHizliAtaForm(f => ({...f, marka: e.target.value}))} placeholder="Apple, Dell..."
                        style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
                    </div>
                    <div>
                      <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Model</label>
                      <input value={hizliAtaForm.model} onChange={e => setHizliAtaForm(f => ({...f, model: e.target.value}))} placeholder="MBP M3..."
                        style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
                    </div>
                    <div style={{ gridColumn: '1/-1' }}>
                      <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Seri No</label>
                      <input value={hizliAtaForm.seri_no} onChange={e => setHizliAtaForm(f => ({...f, seri_no: e.target.value}))} placeholder="Cihaz seri numarası"
                        style={{ width: '100%', padding: '9px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
                    </div>
                  </div>
                )}
              </div>

              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Atama Tarihi *</label>
                <input type="date" value={hizliAtaForm.atama_tarihi} onChange={e => setHizliAtaForm(f => ({...f, atama_tarihi: e.target.value}))}
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Not</label>
                <input value={hizliAtaForm.atama_notu} onChange={e => setHizliAtaForm(f => ({...f, atama_notu: e.target.value}))} placeholder="İsteğe bağlı not"
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
              </div>
            </div>

            <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
              <button onClick={() => setModalTur(null)} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1.5px solid #E5E7EB', background: '#fff', cursor: 'pointer', fontWeight: 600 }}>İptal</button>
              <button onClick={hizliAtaKaydet} style={{ flex: 2, padding: '10px', borderRadius: '8px', border: 'none', background: '#059669', color: '#fff', cursor: 'pointer', fontWeight: 600 }}>Ata</button>
            </div>
          </div>
        </div>
      )}

      {modalTur === 'iade' && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '16px', padding: '32px', width: '100%', maxWidth: '380px', boxShadow: '0 25px 50px rgba(0,0,0,0.25)' }}>
            <h2 style={{ fontSize: '20px', fontWeight: 700, margin: '0 0 8px' }}>Zimmet İade Al</h2>
            <p style={{ color: '#6B7280', fontSize: '14px', marginBottom: '20px' }}>
              <strong>{secili?.zimmet_ad}</strong> — <strong>{secili?.personel_ad}</strong>
            </p>
            {hata && <div style={{ background: '#FEF2F2', color: '#DC2626', padding: '10px', borderRadius: '8px', marginBottom: '14px', fontSize: '14px' }}>⚠️ {hata}</div>}
            {basari && <div style={{ background: '#F0FDF4', color: '#16A34A', padding: '10px', borderRadius: '8px', marginBottom: '14px', fontSize: '14px' }}>✅ {basari}</div>}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>İade Tarihi *</label>
                <input type="date" value={iadeForm.iade_tarihi} onChange={e => setIadeForm(f => ({ ...f, iade_tarihi: e.target.value }))}
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>İade Notu</label>
                <textarea value={iadeForm.iade_notu} onChange={e => setIadeForm(f => ({ ...f, iade_notu: e.target.value }))} rows={3}
                  placeholder="Cihazın durumu, hasar var mı..."
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', resize: 'vertical', boxSizing: 'border-box' }} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
              <button onClick={() => setModalTur(null)} style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1.5px solid #E5E7EB', background: '#fff', cursor: 'pointer', fontWeight: 600 }}>İptal</button>
              <button onClick={iadeAl} style={{ flex: 2, padding: '10px', borderRadius: '8px', border: 'none', background: '#D97706', color: '#fff', cursor: 'pointer', fontWeight: 600 }}>İade Al</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
